<script>
    import Dashboard from "../../../Models/dashboardModel";
    import Loader from "../../Loader.svelte";
    import { db } from '../../../Database.svelte';
    import {addModal} from '../../ModalManager.svelte';
    import {notifier} from "@beyonk/svelte-notifications";
    import { groupBy } from "lodash-es";

    import DashboardControlMappingModal from "../Sections/DashboardControlMappingModal.svelte";
    import QuestionLibrary from "../../../Models/QuestionLibraryModel";

    export let section;
    export let assessment_type_model;
    export let assessment_type;

    let library_controls = {};
    let controls;
    let control_map = {};

    async function getCategoryLibrary(category) {
        let category_library = await QuestionLibrary.getStatic(category.details.library_id);

        return category_library;
    }

    async function loadLibraryControls(assessment_type) {
        let ctrls = [];
        for (let category of Object.values(assessment_type.categories)) {
            if (category.details.library_id) {
                let category_library = await getCategoryLibrary(category);

                for (let subcategory of category_library.subcategories) {
                    for (let control of subcategory.controls) {
                        ctrls.push({
                            id: control.details.child_id,
                            details: control.details
                        })
                        control_map[control.details.child_id] = control.details;
                    }
                }

            } else {
                for (let subcategory of Object.values(category.subcategories)) {
                    if (subcategory.details.library_id) {
                        let subcategory_library = await getCategoryLibrary(subcategory);

                        for (let control of subcategory_library.controls) {
                            ctrls.push({
                                id: control.details.child_id,
                                details: control.details
                            })

                            control_map[control.details.child_id] = control.details;
                        }
                    } else {
                        for (let control of Object.values(subcategory.controls)) {
                            if (control.library_id) {
                                let control_details = await db.get(control.library_id);

                                library_controls[control._id] = control_details;

                                ctrls.push({
                                    id: control._id,
                                    details: control_details
                                })
                                control_map[control_details.child_id] = control_details;
                            } else {
                                ctrls.push({
                                    id: control._id,
                                    details: control
                                })
                                control_map[control.control_id] = control;

                            }
                        }
                    }
                }
            }
        }
        controls = ctrls;
    }

    function getControl(controls, control_id) {
        if (control_map[control_id]) return control_map[control_id]

        for (let control of controls) {
            if (control.id == control_id) {
                return control.details;
            }
        }

        return null;
    }

    function mapControl(item) {
        addModal(DashboardControlMappingModal, {
            controls
        }).then(async (ctrls) => {
            let promises = [];
            for (let control_id of ctrls) {
                promises.push(assessment_type_model.addDashboardMapping($dashboard.details, item, control_id));
            }

            await Promise.all(promises);
            notifier.success("Mappings Added");
        })
    }

    $: dashboard = new Dashboard(section.dashboard_type).store;

    // $: filterControls(searchFilter)
    $: loadLibraryControls($assessment_type)
</script>

<Loader loading={!($dashboard && controls)}>
    <div class="columns is-multiline">
        {#each $dashboard.items as item}
            <div class="column is-2 card">
                <p>{item.Name}</p>
                <hr>
                <h3 class="title is-5">Library Mappings</h3>
                {#if item.library_mappings}
                    <div class="tags mappings">
                        <div class="field is-grouped is-grouped-multiline">
                            {#each item.library_mappings as mapping}
                                {#if control_map[mapping.control_id]}
                                    <div class="control">
                                        <div class="tags has-addons" title={control_map[mapping.control_id].text}>
                                            <span class="tag">{control_map[mapping.control_id].control_number} {control_map[mapping.control_id].name}</span>
                                        </div>
                                    </div>
                                {/if}
                            {/each}
                        </div>
                    </div>
                {/if}
                <hr>
                <h3 class="title is-5">Assessment Type Mappings</h3>
                {#if $assessment_type.dashboard_mappings[$dashboard.details._id] && controls.length}
                    <div class="tags">
                        <div class="field is-grouped is-grouped-multiline">
                            {#each $assessment_type.dashboard_mappings[$dashboard.details._id][item.item_id] || [] as map}
                                {@const control = getControl(controls, map.mapped_control)}
                                <div class="control">
                                    <div class="tags has-addons">
                                        <span class="tag">
                                            {#if control}
                                                {control.control_number} {control.name}
                                            {:else}
                                                Control Doesn't Exist
                                            {/if}
                                        </span>
                                        <span class="tag is-light is-delete pointer" on:click={() => $assessment_type.model.deleteDashboardMapping(map)}></span>

                                    </div>
                                </div>
                            {/each}
                        </div>
                    </div>

                {/if}
                <div class="button is-info" on:click={()=> mapControl(item)}>Map Controls</div>
            </div>
        {/each}
    </div>
</Loader>

<style>
    .column.card {
        margin: 10px;
    }
</style>